import React, { useEffect, useState } from "react";
import "./Promotion.css"; // styles below
import { Alert, Box, CircularProgress, Grid, IconButton, ListItem, ListItemButton, ListItemText, Modal, Snackbar, TextField, Typography } from "@mui/material";
import RButton from "../../components/RButton";
import { Button } from "react-bootstrap";
import PromotionPreviewCard from "./PromotionPreviewCard";
import RedemptionCard from "./RedemptionCard";
import { getPromoCode, updateKaratPromoOffer } from "../../API/SponsoredAPI/SponsoredApi";
import { GridCloseIcon } from "@mui/x-data-grid";

const Promotion = ({ offers, loading,value,handleViewMore }) => {
  console.log(offers);
  const token = sessionStorage.getItem("token");
  const [promoOffers, setPromoOffers] = useState(offers);
  const [showModal,setShowModal] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [formData, setFormData] = useState({});
  const [screenType, setScreenType] = useState('');
  const [message, setMessage] = useState('');
  const [isErr,setIsErr] = useState(false);

  const handleSelectOffer = (offer) => {
    setSelectedOffer(offer);
    setFormData({ ...offer }); // clone it into formData
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name.startsWith('sponsorDetails.')) {
      const key = name.split('.')[1];
      setFormData((prev) => {
        const updated = {
            ...prev,
            sponsorDetails: {
              ...prev.sponsorDetails,
              [key]: value,
            },
          };
          setSelectedOffer(updated);  // update selectedOffer too
          return updated;
      });
    } else {
        setFormData((prev) => {
            const updated = {
              ...prev,
              [name]: value,
            };
            setSelectedOffer(updated);  // update selectedOffer too
            return updated;
          });
    }
  };

  const editPayload = {
    title: formData?.title,
    description: formData?.description,
    winPromoCode: formData?.winPromoCode,
    sponsorDetails: {
      logoUrl: formData?.sponsorDetails?.logoUrl,
      websiteUrl: formData?.sponsorDetails?.websiteUrl,
      imageUrl: formData?.sponsorDetails?.imageUrl ?? 'sddd',
      termsConditionsUrl:
      formData?.sponsorDetails?.termsConditionsUrl ?? 'terms',
      maxParticipantsLimit: formData?.sponsorDetails?.maxParticipantsLimit,
      expiredDate: formData?.sponsorDetails?.expiredDate,
      sponsorName: formData?.sponsorDetails?.sponsorName,
    },
    ...(screenType === 'UsersChoice' &&
    {
      userChoiceOutcomePrediction: {
        leftOptionDescription:
        formData?.userChoiceOutcomePrediction?.leftOptionDescription,
        leftOptionImageUrl:
        formData?.userChoiceOutcomePrediction?.leftOptionImageUrl,
        rightOptionDescription:
        formData?.userChoiceOutcomePrediction?.rightOptionDescription,
        rightOptionImageUrl:
        formData?.userChoiceOutcomePrediction?.rightOptionImageUrl,
      },
    }),
  }

  const handleSubmit = () => {
    setMessage('');
    setIsErr(false);
  setPromoOffers((prev) =>
    prev.map((offer) =>
      offer.gameID === formData.gameID ? { ...formData } : offer
    )
  );

  updateKaratPromoOffer(token, selectedOffer?._id, editPayload)
          .then(res => {
            console.log('Promo updated success : ', res);
            setShowModal(true);
            setMessage(res?.data?.message);
          })
          .catch(error => {
            //setIsCreateOfferBtnClicked(false);
            console.log('limits error : ', error);
            setIsErr(true);
            setShowModal(true);
            const errorMessage =
              error?.response?.data?.error || 'An unknown error occurred'
              setMessage(errorMessage);
          });
};

  if (loading) {
    return (
      <div className="promotion-loading">
        <CircularProgress  color="warning" />
      </div>
    );
  }

  const action = (
    <React.Fragment>
      {/* <Button color="secondary" size="small" onClick={()=>{setShowModal(false)}}>
        UNDO
      </Button> */}
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={()=>{setShowModal(false)}}
      >
        <GridCloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const formatDate = (gameTime) => {
    const date = new Date(gameTime);
    const day = date.toLocaleString("en-US", { weekday: "short" });
    const month = date.toLocaleString("en-US", { month: "short" });
    const ordinal =
      date.getDate() +
      (["th", "st", "nd", "rd"][
        (date.getDate() % 10 > 3 || ~~(date.getDate() % 100 / 10) === 1)
          ? 0
          : date.getDate() % 10
      ] || "th");
    const time = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    return `${day} ${month} ${ordinal} ${time}`;
  };

  return (

    <>
            <Snackbar
            anchorOrigin={{vertical:"top",horizontal:'center'}}
            open={showModal}
            autoHideDuration={6000}
            onClose={()=>{setShowModal(false)}}
            message={message}
            action={action}
            >
                 <Alert
                    onClose={()=>{setShowModal(false)}}
                    severity={isErr?"error":"success"}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                {message}
            </Alert>
            </Snackbar>
        {/* Modal */}
      

    <div className="promotion-container">
   
   <div className="promotion-list">
     <h5>Promotional Offers</h5>
     <ul>
       {offers.map((offer, index) => (
         <ListItem key={index} disablePadding>
         <ListItemButton
         className={`side-nav-item ${selectedOffer?.gameID === offer.gameID ? 'selected' : ''}`}
           selected={selectedOffer?.gameID === offer.gameID}
           onClick={() => handleSelectOffer(offer)}
         >
           <ListItemText
            primaryTypographyProps={{
                fontSize: 14,
              }}
              secondaryTypographyProps={{
                fontSize: 12,
              }}
             primary={offer.title}
             secondary={formatDate(offer?.gameTime)}
           />
         </ListItemButton>
       </ListItem>
       ))}
     </ul>

 {/* View More Button */}
 {offers.length >= 10 && (
    <div style={{ textAlign: 'center', marginTop: '1rem' }}>
      <RButton variant="contained" onClick={handleViewMore} title="View More" />
      
    </div>
  )}

   </div>

   <div className="promotion-details">
     {selectedOffer ? (
      <Box
      sx={{
        p: 2,
        border: '1px solid #ddd',
        borderRadius: 4,
        background: '#fdfdfb',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)'
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
       {value === 1 ? 'Settled':'Edit'}  Promotional Offer
      </Typography>

      <Grid container spacing={2}>

          <Grid  item xs={6}>
        
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                disabled
                label="Game ID"
                name="gameID"
                value={formData.gameID}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                disabled
                label="League Name"
                name="leagueName"
                value={formData.leagueName}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                disabled
                label="Team Name"
                name="teamName"
                value={formData.teamName}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                disabled
                label="Opponent Team Name"
                name="opponentTeamName"
                value={formData.opponentTeamName}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                disabled
                label="Team Key"
                name="teamKey"
                value={formData.teamKey}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                disabled
                label="Opponent Team Key"
                name="opponentTeamKey"
                value={formData.opponentTeamKey}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Promo Title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Promo Description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                multiline
                rows={2}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                disabled
                label="Game Time"
                name="gameTime"
                value={formatDate(formData.gameTime)}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Promo Code"
                name="winPromoCode"
                value={formData.winPromoCode}
                onChange={handleChange}
                fullWidth
              />
            </Grid>


            {/* Sponsor Details */}
            <Grid item xs={12}>
              <Typography variant="subtitle1">Sponsor Details</Typography>
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Sponsor Name"
                name="sponsorDetails.sponsorName"
                value={formData.sponsorDetails.sponsorName}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Logo URL"
                name="sponsorDetails.logoUrl"
                value={formData.sponsorDetails.logoUrl}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Website URL"
                name="sponsorDetails.websiteUrl"
                value={formData.sponsorDetails.websiteUrl}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Image URL"
                name="sponsorDetails.imageUrl"
                value={formData.sponsorDetails.imageUrl}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Terms & Conditions URL"
                name="sponsorDetails.termsConditionsUrl"
                value={formData.sponsorDetails.termsConditionsUrl}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
          </Grid>

         {
            value === 0 && (
                <>

                    <Typography
                        variant="caption"
                        sx={{ mt: 3, display: 'block', color: 'error.main' }}
                    >
                       Note* : If users have already started joining this promotion, you will not be able to update it.
                    </Typography>
                    <Box sx={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'150px',mt:1}}>
                    <RButton variant="contained" onClick={handleSubmit} title={selectedOffer?.gameID ? "Update" : "Create"} disabled={selectedOffer?.capacityLimit > 0 ? true:false} />
                    </Box>

                   
                    </>
            )
         } 
          </Grid>
 
           {/* Right: Preview */}
           <Grid item xs={6} sx={{ pl: 2,justifyContent:'center',alignItems:"center" }} gap={8}>
           <PromotionPreviewCard  offerData={selectedOffer} />
           <RedemptionCard offerData={selectedOffer} isEdit={true} promoType="Winner" />

          </Grid>



          </Grid>
    </Box>
     ) : (
       <div>
         <h6>Select an offer to view details</h6>
       </div>
     )}
   </div>
 </div>
    </>
   
  );
};

export default Promotion;
